module.exports = __webpack_public_path__ + "img/compliance1.43d7b0d3.svg";